import React from "react";
import numeral from "numeral";
import { useIntl, FormattedMessage } from "react-intl";
import { Input } from "@ts-digital/vrc";
import { Select } from "antd";
import { deadlineModePayment } from "../../../../constants/scadenze";
import { VaporDatePicker } from "../../../vapor";

const Option = Select.Option;

const FormNew = props => {
  const {
    selectedRows,
    deadlineDate,
    deadlineDescription,
    deadlinePayment,
    setDeadlineDate,
    setDeadlineDescription,
    setDeadlinePayment,
    errorDate,
    errorDescription,
    errorPayment
  } = props;

  const intl = useIntl();
  const description2Text = intl.formatMessage({ id: "deadlines.merge.description2" });
  const genericDescription = intl.formatMessage({ id: "generic.description" });
  const placeholderDescription = intl.formatMessage({
    id: "deadlines.merge.placeholderDescription"
  });
  const deadlineDateNew = intl.formatMessage({
    id: "deadlines.merge.deadlineDateNew"
  });
  const amountText = intl.formatMessage({ id: "deadlines.amount" });
  const placeholderPaymentText = intl.formatMessage({
    id: "deadlines.merge.placeholderPayment"
  });

  const RenderSelectText = (input, option) => {
    return (useIntl()
      .formatMessage({ id: option.children.props.id })
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
    );
  };

  let finalAmount = 0;  
  finalAmount = selectedRows.reduce((a, b) => {
    return (typeof a === "object" ? a.amount : a) + b.amount;
  });

  const renderDeadlinesPaymentType = () => {
    let items = [];
    deadlineModePayment.map(item => {
      return items.push(<Option value={item.key}>
        { 
          intl.formatMessage({ id: item.desc })
        }
      </Option>);
    });
    return items;
  };

  return (
    <div>
      <div className={"deadlinesDialogMerge-description2"}>
        {description2Text}
      </div>
      <section className={"deadlinesDialogMerge-form2"}>
        <div className={"deadlinesDialogMerge-form2-row"}>
          <div
            className={
              "deadlinesDialogMerge-form2-description" +
              (errorDescription ? " error" : "")
            }
          >
            <Input
              label={
                genericDescription + " *"
              }
              value={deadlineDescription}
              onChange={value => {
                setDeadlineDescription(value);
              }}
              fieldName="deadline-description"
              placeholder={placeholderDescription}
            />
          </div>
        </div>
        <div className={"deadlinesDialogMerge-form2-row row2"}>
          <div className={"deadlinesDialogMerge-form2-date"}>
            <span>
              {deadlineDateNew}{" "}
              *
            </span>
            <VaporDatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              className={
                "deadlinesDialogMerge-form2-dateWidget" +
                (errorDate ? " error" : "")
              }
              value={deadlineDate}
              onChange={value => {
                setDeadlineDate(value);
              }}
            />
          </div>
          <div className={"deadlinesDialogMerge-form2-amount"}>
            <Input
              disabled
              label={amountText + " *"}
              value={numeral(Math.abs(finalAmount)).format("0,0.00") + " €"}
              fieldName="deadline-date"
            />
          </div>
        </div>
        <div className={"deadlinesDialogMerge-form2-row"}>
          <div className={"deadlinesDialogMerge-form2-payment"}>
            <span>
              <FormattedMessage id={finalAmount >= 0
                ? "deadlines.pages.table.paymentTypePlus"
                : "deadlines.pages.table.paymentTypeMinus"} /> *
            </span>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  RenderSelectText(input, option)
                );
              }}
              className={
                "deadlinesDialogMerge-form2-paymentWidget" +
                (errorPayment ? " error" : "")
              }
              value={deadlinePayment}
              onChange={value => {
                setDeadlinePayment(value);
              }}
              getPopupContainer={trigger => trigger.parentNode}
              fieldName="deadline-payment"
              placeholder={placeholderPaymentText}
            >
              {renderDeadlinesPaymentType()}
            </Select>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FormNew;
